/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './dropdown-container.stache';
import appContext from 'scripts/app-context';
import can from 'can';
import DropdownSearch from 'components/dropdown/dropdown-container/dropdown-search';

Component.extend({
    tag: 'dropdown-container',
    template: template,
    leakScope: false,
    viewModel: {
        title: '',
        define: {
            search: {
                Type: DropdownSearch,
                Value: null,
            },
            value: {
                type: 'string',
            },
            searchValue: {
                type: 'string',
                value: '',
            },
            label: {
                type: 'string',
                value: null,
            },
            expandExtraLarge: {
                type: 'htmlbool',
                value: false,
            },
            expandLarge: {
                type: 'htmlbool',
                value: false,
            },
            expandMediumUp: {
                type: 'htmlbool',
                value: false,
            },
            expandMedium: {
                type: 'htmlbool',
                value: false,
            },
            alignRight: {
                type: 'htmlbool',
                value: false,
            },
            items: {
                Type: can.List,
                Value: can.List,
            },
            links: {
                Type: can.List,
                Value: can.List,
            },
            className: {
                type: 'string',
                value: '',
            },
            lockScroll: {
                type: 'boolean',
                value: true,
            },
            results: {
                Type: can.Map,
                Value: can.Map,
            },
            hideFilter: {
                type: 'boolean',
                value: false,
            },
        },
        filterItems(value) {
            this.attr('searchValue', value);
        },
    },
    events: {
        inserted(element) {
            this.dropdownContainer = element.find('.c-dropdown');
            this.updateTitle(this.viewModel.attr('value'));
            this.viewModel.bind('value', (event, value) => {
                this.updateTitle(value);
                this.viewModel.dispatch({
                    type: 'onChange',
                    payload: { value: value },
                });
            });
            this.viewModel.bind('results', () => {
                this.updateTitle();
            });
            this.viewModel.attr('items').bind('add', () => {
                this.updateTitle();
            });
        },

        closeDropdown() {
            this.dropdownContainer.removeClass('is-opened');
            if (
                appContext.model.screen.attr('screenSize') === 'extra-small' &&
                this.viewModel.attr('lockScroll')
            ) {
                appContext.model.dispatch('page-scroll-toggle', [false]);
            }
        },

        updateTitle(value) {
            const checkValue = value || this.viewModel.attr('value');
            //after rendering all items and links
            setTimeout(() => {
                can.batch.start();
                this.viewModel.attr('items').forEach((item) => {
                    item.attr('selected', false);
                    if (item.attr('value') == checkValue) {
                        item.attr('selected', true);
                        this.viewModel.attr('title', item.attr('title'));
                    }
                });
                this.viewModel.attr('links').forEach((item) => {
                    if (item.attr('isActive')) {
                        this.viewModel.attr('title', item.attr('title'));
                    }
                });
                can.batch.stop();
            }, 0);
        },

        '{scope} searchValue'(scope, event, searchValue) {
            const filter = this.viewModel.attr('search.filter');
            if (filter) {
                can.batch.start();
                let resultsNotExist = false;
                this.viewModel.attr('items').forEach((item) => {
                    let display = filter(item, searchValue);
                    item.attr('display', display);
                });
                if (
                    this.viewModel
                        .attr('items')
                        .serialize()
                        .every((it) => !it.display)
                ) {
                    resultsNotExist = true;
                }
                this.viewModel.attr('links').forEach((item) => {
                    item.attr('display', filter(item, searchValue));
                });
                this.viewModel.attr('resultsNotExist', resultsNotExist);
                can.batch.stop();
            }
        },

        'dropdown-item click'(element) {
            const value = element.viewModel().attr('value');
            this.updateTitle(value);
            this.closeDropdown();
            setTimeout(() => {
                this.viewModel.attr('value', value);
            }, 0);
        },

        'dropdown-link click'(element) {
            this.closeDropdown();
        },

        '.js-selected-item click'(element, event) {
            if (this.dropdownContainer.hasClass('is-opened')) {
                this.closeDropdown();
            } else {
                this.dropdownContainer.addClass('is-opened');
                if (
                    appContext.model.screen.attr('screenSize') ===
                        'extra-small' &&
                    this.viewModel.attr('lockScroll')
                ) {
                    appContext.model.dispatch('page-scroll-toggle', [true]);
                }
            }
        },

        '.s-btn-close click'() {
            this.closeDropdown();
            if (this.viewModel.attr('lockScroll')) {
                appContext.model.dispatch('page-scroll-toggle', [false]);
            }
        },

        '{document} click'(element, event) {
            if (this.dropdownContainer.hasClass('is-opened')) {
                if (!this.element.get(0).contains(event.target)) {
                    this.closeDropdown();
                }
            }
        },
    },
});
